import React from "react"

import * as s from "./TextRow.module.scss"

export const TextRow = ({ data }) => {
  const { title, blurb } = data

  return (
    <div className={s.Wrapper}>
      <div className={s.Inner}>
        <h4 className={s.Inner__title}>{title}</h4>
        <p className={s.Inner__blurb}>{blurb}</p>
      </div>
    </div>
  )
}
